(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb-home-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eb-home-promo')) {
    customElements.define('eb-home-promo', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.track = this.querySelector('.eb-home-promo__track');
        this.slides = [...this.querySelectorAll('.eb-home-promo__slide')];
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.current = 0;
        this.visible = true;
        this.hovered = false;
        this.held = false;
        this.keyboardFocus = false;
        this.editorSelected = false;
        this.moving = false;
        this.offset = this.slides.length > 1 ? 1 : 0;
        this.delay = Math.max(5000, Number(this.dataset.delay) || 5000);
        // Boundary copies let the last offer advance left into the first one.
        if (this.offset) {
          const clone = slide => {
            const copy = slide.cloneNode(true);
            copy.setAttribute('data-promo-clone', '');
            copy.inert = true;
            copy.setAttribute('aria-hidden', 'true');
            [copy, ...copy.querySelectorAll('[id], [data-shopify-editor-block]')].forEach(node => {
              node.removeAttribute('id'); node.removeAttribute('data-shopify-editor-block');
            });
            this.track.append(copy);
            return copy;
          };
          this.track.prepend(clone(this.slides[this.slides.length - 1]));
          clone(this.slides[0]);
        }
        this.snap();
        this.querySelector('.eb-home-promo__controls')?.removeAttribute('hidden');
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.go(this.current + Number(button.dataset.step)), options));
        this.dots.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', event => {
          this.keyboardFocus = event.target.matches(':focus-visible'); this.schedule();
        }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.keyboardFocus = false; this.schedule(); }
        }, options);
        this.track.addEventListener('pointerdown', () => { this.held = true; this.schedule(); }, options);
        const release = () => { if (this.held) { this.held = false; this.schedule(); } };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(), 140);
        }, {passive:true, ...options});
        this.track.addEventListener('scrollend', () => this.settle(), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.resize = new ResizeObserver(() => this.snap());
        this.resize.observe(this.track);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.indexOf(event.target.closest('.eb-home-promo__slide'));
          if(index >= 0) { this.editorSelected = true; this.go(index); }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
        this.sync(); this.schedule();
      }
      sync() {
        this.dots.forEach((dot,index) => dot.setAttribute('aria-current', String(index === this.current)));
        this.slides.forEach((slide,index) => { slide.inert = index !== this.current; slide.setAttribute('aria-hidden', String(index !== this.current)); });
      }
      snap() {
        this.track.scrollTo({left:(this.current + this.offset) * this.track.clientWidth,behavior:'instant'});
        this.moving = false;
      }
      settle() {
        clearTimeout(this.settleTimer);
        if (this.held || !this.track.clientWidth) return;
        const physical = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.current = (physical - this.offset + this.slides.length) % this.slides.length;
        this.moving = false;
        if (this.offset && (physical === 0 || physical === this.slides.length + 1)) this.snap();
        this.sync();
      }
      go(index) {
        if (this.moving) return;
        const physical = index < 0 ? 0 : index >= this.slides.length ? this.slides.length + 1 : index + this.offset;
        this.current = (index + this.slides.length) % this.slides.length;
        this.moving = Math.abs(this.track.scrollLeft - physical * this.track.clientWidth) > 1;
        this.track.scrollTo({left:physical * this.track.clientWidth,behavior:this.motion.matches ? 'instant' : 'smooth'});
        this.sync(); this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if(this.dataset.autoplay !== 'true' || this.motion.matches || this.hovered || this.held || this.keyboardFocus || this.editorSelected || !this.visible || document.hidden || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.go(this.current + 1), this.delay);
      }
      disconnectedCallback() {
        clearTimeout(this.timer); clearTimeout(this.settleTimer);
        this.controller?.abort(); this.controller = null;
        this.observer?.disconnect(); this.resize?.disconnect();
        this.querySelectorAll('[data-promo-clone]').forEach(copy => copy.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebprime-daily-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-eb-daily-offer]');
    const root = roots[roots.length - 1];
    if (!root || root.dataset.trackingReady === 'true') return;
    root.dataset.trackingReady = 'true';

    const apiUrl = root.dataset.apiUrl;
    const link = root.querySelector('[data-eb-daily-offer-link]');
    const label = root.querySelector('[data-eb-daily-offer-label]');
    const text = root.querySelector('[data-eb-daily-offer-text]');
    const cta = root.querySelector('[data-eb-daily-offer-cta]');
    if (!apiUrl || !link) return;

    const visitorKey = 'ebdo_visitor_id';
    const clickKey = 'ebdo_last_click';

    function visitorId() {
      try {
        let value = localStorage.getItem(visitorKey);
        if (!value) {
          value = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
          localStorage.setItem(visitorKey, value);
        }
        return value;
      } catch (error) {
        return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      }
    }

    function offerDestination(offer) {
      if (!offer?.link) return '';

      const destination = new URL(offer.link, window.location.origin);
      if (destination.origin !== window.location.origin || destination.pathname !== '/search') {
        return destination.toString();
      }

      const familyMap = {
        classic: 'clasice',
        short: 'scurte',
        kids: 'copii',
        'women-short': 'dama',
        slippers: 'talpici',
        terry: 'flausate',
      };
      const rules = Array.isArray(offer.rules) ? offer.rules : [];
      const families = [...new Set(rules.map((rule) => familyMap[rule.family]).filter(Boolean))];
      const packs = [...new Set(rules.map((rule) => String(rule.pack || '')).filter(Boolean))];

      destination.searchParams.set('q', 'sosete');
      destination.searchParams.set('type', 'product');
      destination.searchParams.set('options[prefix]', 'last');
      destination.searchParams.set('eb_query', 'sosete');
      if (families.length) destination.searchParams.set('eb_family', families.join(','));
      if (packs.length === 1) destination.searchParams.set('eb_pack', packs[0]);

      return destination.toString();
    }

    function applyOffer(payload) {
      const offer = payload?.offer;
      if (!offer || !offer.enabled) return;
      if (label && offer.label) label.textContent = offer.label;
      if (text && offer.text) text.textContent = offer.text;
      if (cta && offer.cta) cta.textContent = offer.cta;
      if (offer.link) link.href = offerDestination(offer);
      root.dataset.offerDate = payload.date || '';
      root.dataset.offerDay = String(payload.day ?? '');
    }

    fetch(apiUrl, {headers: {Accept: 'application/json'}})
      .then((response) => response.ok ? response.json() : null)
      .then(applyOffer)
      .catch(() => {});

    async function attachClickToCart(click) {
      const rootPath = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootPath}cart/update.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          attributes: {
            _eb_offer_click_id: click.click_id,
            _eb_offer_date: click.offer_date,
            _eb_offer_day: String(click.offer_day),
          },
        }),
      });
      if (!response.ok) throw new Error('Atribuirea cosului a esuat.');
    }

    async function trackClick() {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          visitor_id: visitorId(),
          page_url: window.location.href,
          referrer: document.referrer || '',
        }),
      });
      if (!response.ok) throw new Error('Clickul nu a putut fi salvat.');
      const click = await response.json();
      if (!click?.ok || !click.click_id) throw new Error('Raspuns invalid.');
      await attachClickToCart(click);
      try { localStorage.setItem(clickKey, JSON.stringify(click)); } catch (error) {}
      return click;
    }

    link.addEventListener('click', async (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (link.dataset.tracking === 'true') return;
      link.dataset.tracking = 'true';
      const destination = link.href;
      const timeout = new Promise((resolve) => setTimeout(resolve, 1800));
      try { await Promise.race([trackClick(), timeout]); } catch (error) {}
      window.location.assign(destination);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
